"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _LoginMenu = _interopRequireDefault(require("@airasia/phoenix-components/components/LoginMenu"));

var _LoginTooltip = _interopRequireDefault(require("@airasia/phoenix-components/components/LoginTooltip"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _Spinner = _interopRequireDefault(require("@airasia/phoenix-components/components/Spinner"));

var _constant = require("../constant");

var _utilities = _interopRequireDefault(require("../../utilities"));

var _index = _interopRequireDefault(require("./SSOWidgetHandler/index"));

var _constant2 = require("./constant");

var _login = _interopRequireDefault(require("./login.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var MenuOrientation = function MenuOrientation(MenuOnLeft) {
  if (MenuOnLeft) {
    return "left: 0;";
  }

  return 'right: 0';
};

var LoginMenuWrapper = _styledComponents.default.div.withConfig({
  displayName: "Login__LoginMenuWrapper",
  componentId: "vur044-0"
})(["position:absolute;min-width:362px;top:calc(100% + 4px);", ""], function (_ref) {
  var MenuOnLeft = _ref.MenuOnLeft;
  return MenuOrientation(MenuOnLeft);
});

var TopContainer = _styledComponents.default.div.withConfig({
  displayName: "Login__TopContainer",
  componentId: "vur044-1"
})(["position:relative;display:inline-flex;justify-content:center;align-items:center;"]);

var CustomIcon = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "Login__CustomIcon",
  componentId: "vur044-2"
})([""]);

var getColors = function getColors(loginStatus, loginclicked, theme) {
  if (loginclicked) {
    return "".concat(theme.colors.primaryDark);
  }

  if (loginStatus) {
    return "".concat(theme.colors.greyDarker);
  }

  return "".concat(theme.colors.primary);
};

var LoginIcon = (0, _styledComponents.default)(function (_ref2) {
  var iconColor = _ref2.iconColor,
      className = _ref2.className,
      iconType = _ref2.iconType;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(CustomIcon, {
    icon: iconType,
    fontsize: _constant2.DEFAULT_CONFIG.TITLE_NORMAL,
    color: iconColor,
    accessible: false
  }));
}).withConfig({
  displayName: "Login__LoginIcon",
  componentId: "vur044-3"
})(["height:24px;width:24px;margin-right:", ";svg{display:block;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.XSmall;
});
var CustomText = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "Login__CustomText",
  componentId: "vur044-4"
})(["border-bottom:", ";", ";outline:none;line-height:", ";padding:", " 0px;"], function (_ref4) {
  var loginclicked = _ref4.loginclicked,
      showTooltip = _ref4.showTooltip,
      theme = _ref4.theme;
  return (loginclicked || showTooltip) && "1px solid ".concat(theme.colors.primaryDark);
}, function (_ref5) {
  var loginStatus = _ref5.loginStatus,
      loginclicked = _ref5.loginclicked,
      theme = _ref5.theme;
  return (0, _styledComponents.css)(["color:", ";"], getColors(loginStatus, loginclicked, theme));
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.lineHeight.large;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.micro;
});
var HoverStyle = (0, _styledComponents.css)(["&:hover ", "{color:", ";}&:hover ", "{color:", ";}"], CustomIcon, function (props) {
  return props.theme.colors.greyDarker;
}, CustomText, function (props) {
  return props.theme.colors.greyDarker;
});

var LoginTabContainer = _styledComponents.default.div.withConfig({
  displayName: "Login__LoginTabContainer",
  componentId: "vur044-5"
})(["display:inline-flex;cursor:pointer;align-items:center;", ""], function (_ref8) {
  var loginclicked = _ref8.loginclicked,
      showTooltip = _ref8.showTooltip;
  return !(showTooltip || loginclicked) && HoverStyle;
});

var LoginTab = (0, _styledComponents.default)(function (props) {
  var handleClick = props.handleClick,
      className = props.className,
      tabIndex = props.tabIndex,
      loginInfo = props.loginInfo,
      loginStatus = props.loginStatus,
      loginclicked = props.loginclicked,
      showTooltip = props.showTooltip,
      showIcon = props.showIcon,
      iconType = props.iconType,
      load = props.load,
      idConfig = props.idConfig;

  var _ref9 = idConfig || {},
      widgetName = _ref9.widgetName,
      parentName = _ref9.parentName,
      index = _ref9.index;

  var _useState = (0, _react.useState)('login'),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      dynamicID = _useState2[0],
      setId = _useState2[1];

  (0, _react.useEffect)(function () {
    var url = 'login';

    if (parentName) {
      url = "".concat(parentName, "-login");
    }

    if (index) {
      url += "-".concat(index);
    }

    if (widgetName) {
      url = "".concat(widgetName, "-").concat(url);
    }

    setId(url);
  }, [widgetName, parentName, index]);

  var iconColor = function iconColor() {
    if (!loginStatus) {
      return _constant2.DEFAULT_CONFIG.ICON.COLOR.PRIMARY;
    }

    if (loginclicked) {
      return _constant2.DEFAULT_CONFIG.ICON.COLOR.PRIMARY_DARK;
    }

    return _constant2.DEFAULT_CONFIG.ICON.COLOR.GREY_DARK;
  };

  return /*#__PURE__*/_react.default.createElement(LoginTabContainer, {
    id: dynamicID,
    className: className,
    onClick: function onClick() {
      var evt = new CustomEvent('loginClicked', {
        detail: true
      });
      window.dispatchEvent(evt);
      handleClick(true);
    },
    onKeyDown: function onKeyDown(e) {
      return _utilities.default.keyDownHandler(e, function () {
        return handleClick(true);
      }, _constant.KEY_CODE.ENTER);
    },
    loginclicked: loginclicked,
    loginStatus: loginStatus,
    showTooltip: showTooltip,
    tabIndex: tabIndex
  }, load && /*#__PURE__*/_react.default.createElement(LoginIcon, {
    iconColor: iconColor(),
    iconType: iconType
  }), load ? showIcon && /*#__PURE__*/_react.default.createElement(CustomText, {
    loginStatus: loginStatus,
    bold: true,
    showTooltip: showTooltip,
    loginclicked: loginclicked,
    textLimit: 16,
    accessible: false
  }, loginInfo) : /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    height: "30px",
    width: "30px"
  }));
}).withConfig({
  displayName: "Login__LoginTab",
  componentId: "vur044-6"
})([""]);

var Login = function Login(props) {
  var loginLabel = props.loginLabel,
      iconType = props.iconType,
      deviceType = props.deviceType,
      loginMenuData = props.loginMenuData,
      HideLoginIconForMobile = props.HideLoginIconForMobile,
      theme = props.theme,
      doPolling = props.doPolling,
      environment = props.environment,
      MenuOnLeft = props.MenuOnLeft,
      enableFavoriteMembers = props.enableFavoriteMembers,
      enableBigPoints = props.enableBigPoints,
      enableCreditBalance = props.enableCreditBalance,
      shouldSetCookie = props.shouldSetCookie,
      setDuplicateCookieAATokens = props.setDuplicateCookieAATokens,
      reloadOnLogin = props.reloadOnLogin,
      reloadOnLogout = props.reloadOnLogout,
      tooltipdata = props.tooltipdata,
      shouldShowTooltip = props.shouldShowTooltip,
      accessible = props.accessible,
      locale = props.locale,
      currency = props.currency,
      customProperties = props.customProperties,
      onUserLoginStatus = props.onUserLoginStatus,
      isScrollTop = props.isScrollTop;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      loginInfo = _useState4[0],
      setLoginInfo = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      loginclicked = _useState6[0],
      setLoginClicked = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      showTooltip = _useState8[0],
      setShowTooltip = _useState8[1];

  var _useState9 = (0, _react.useState)(deviceType !== _constant2.DEVICE_TYPE.DESKTOP),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      isMobile = _useState10[0],
      setIsMobile = _useState10[1];

  var _useState11 = (0, _react.useState)({
    bigmemberId: null,
    loyaltyTier: null
  }),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      userInfo = _useState12[0],
      setUserInfo = _useState12[1];

  var _useState13 = (0, _react.useState)(null),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      bigPoints = _useState14[0],
      setBigPoints = _useState14[1];

  var _useState15 = (0, _react.useState)(null),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      creditBalance = _useState16[0],
      setCreditBalance = _useState16[1];

  var _useState17 = (0, _react.useState)(null),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      loginStatus = _useState18[0],
      setLoginStatus = _useState18[1];

  var _useState19 = (0, _react.useState)(false),
      _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
      load = _useState20[0],
      setLoad = _useState20[1];

  var _useState21 = (0, _react.useState)(enableCreditBalance),
      _useState22 = (0, _slicedToArray2.default)(_useState21, 2),
      showCreditBalance = _useState22[0],
      setShowCreditBalance = _useState22[1];

  var _useState23 = (0, _react.useState)(enableBigPoints),
      _useState24 = (0, _slicedToArray2.default)(_useState23, 2),
      showBigLoyaltyPoints = _useState24[0],
      setShowBigLoyaltyPoints = _useState24[1];

  var tooltipInfo = tooltipdata.find(function (d) {
    return d.data;
  }) ? tooltipdata.find(function (d) {
    return d.data;
  }).data : null;
  var _tooltipInfo = tooltipInfo;

  var _tooltipInfo2 = (0, _slicedToArray2.default)(_tooltipInfo, 1);

  tooltipInfo = _tooltipInfo2[0];
  (0, _react.useEffect)(function () {
    setIsMobile(deviceType !== _constant2.DEVICE_TYPE.DESKTOP);
  }, [deviceType]);
  (0, _react.useEffect)(function () {
    if (!loginStatus) setLoginInfo(loginLabel);
  }, [loginLabel]);
  (0, _react.useEffect)(function () {
    if (loginStatus != null) setLoad(true);
  }, [loginStatus]);
  (0, _react.useEffect)(function () {
    var stopScroll = loginclicked && (isMobile || !loginStatus);
    var $body = document.querySelector('body');

    if (stopScroll) {
      $body.style.overflow = 'hidden'; // $body.style.position = 'fixed';
    } else {
      $body.style.removeProperty('overflow'); // $body.style.removeProperty('position');

      var scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = ''; // eslint-disable-next-line radix

      if (isScrollTop) window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
  }, [loginStatus, loginclicked, isMobile, isScrollTop]);

  var handleClick = function handleClick() {
    setLoginClicked(!loginclicked);
    setShowTooltip(false);
  };

  var handleBigLoyaltyPointsDisplay = function handleBigLoyaltyPointsDisplay(bool) {
    setShowBigLoyaltyPoints(bool);
  };

  var handleCreditBalanceDisplay = function handleCreditBalanceDisplay(bool) {
    setShowCreditBalance(bool);
  };

  var MenuClose = function MenuClose(arg) {
    setLoginClicked(!arg);
  };

  var setLoginStatusCallback = function setLoginStatusCallback(arg) {
    onUserLoginStatus(arg);
    setLoginStatus(arg);
  };

  var setUserInfoCallback = function setUserInfoCallback(arg) {
    localStorage.setItem('lTier', arg.loyaltyTier);
    setUserInfo(arg);
  };

  (0, _react.useEffect)(function () {
    if (loginStatus != null) {
      setShowTooltip(shouldShowTooltip && !loginStatus);
    }
  }, [shouldShowTooltip, loginStatus]);

  var getBaseDomain = function getBaseDomain() {
    var ar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.host.split(':')[0].split('.');
    return ar.length >= 2 ? ".".concat(ar[ar.length - 2], ".").concat(ar[ar.length - 1]) : null;
  };

  var removeCookie = function removeCookie(cookieName) {
    document.cookie = "".concat(cookieName, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=").concat(getBaseDomain(), ";");
  };

  var removeDuplicateCookieOfAATokens = function removeDuplicateCookieOfAATokens() {
    if (setDuplicateCookieAATokens) {
      var cookieName = setDuplicateCookieAATokens.cookieName;
      removeCookie(cookieName);
    }
  };

  var removeAATokensCookie = function removeAATokensCookie() {
    if (shouldSetCookie) {
      removeCookie('aa_tokens');
    }
  };

  var removeBigPointsFromLocalStorage = function removeBigPointsFromLocalStorage() {
    localStorage.removeItem('bp');
    localStorage.removeItem('lTier');
  };

  var reloadPage = function reloadPage() {
    window.location.reload();
  };

  var dispatchEventOnLogout = function dispatchEventOnLogout() {
    var evt = new CustomEvent('uhfLogout', {
      detail: true
    });
    window.dispatchEvent(evt);
  };

  var afterLogoutEventHandler = function afterLogoutEventHandler() {
    if (reloadOnLogout) {
      reloadPage();
    } else {
      setLoginStatus(false);
      dispatchEventOnLogout();
    }
  };

  var logout = function logout() {
    if (typeof window.aaWidget !== 'undefined') {
      window.aaWidget.logout().then(function () {
        removeBigPointsFromLocalStorage();
        removeAATokensCookie();
        removeDuplicateCookieOfAATokens();
        handleClick(false);
        afterLogoutEventHandler();
      });
    }
  };

  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('openLogin', handleClick);
    }

    return function () {
      return typeof window !== 'undefined' ? window.removeEventListener('openLogin', handleClick) : null;
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('tooltipClosed', function () {
        setShowTooltip(false);
      }, {
        once: true
      });
    }

    return function () {
      return typeof window !== 'undefined' ? window.removeEventListener('tooltipClosed', function () {
        setShowTooltip(false);
      }) : null;
    };
  }, []);
  var showIcon = isMobile ? HideLoginIconForMobile : true;

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(TopContainer, customProperties, (!isMobile || !showIcon) && /*#__PURE__*/_react.default.createElement(LoginTab, {
      id: "login-tab",
      handleClick: handleClick,
      loginInfo: loginInfo,
      loginStatus: loginStatus,
      loginclicked: loginclicked,
      showTooltip: showTooltip,
      showIcon: showIcon,
      iconType: iconType,
      tabIndex: tabIndex,
      load: load
    }), loginStatus && loginclicked && /*#__PURE__*/_react.default.createElement(LoginMenuWrapper, {
      id: "login-menu-wrapper",
      MenuOnLeft: MenuOnLeft
    }, /*#__PURE__*/_react.default.createElement(_LoginMenu.default, {
      show: true,
      data: loginMenuData,
      isMobile: isMobile,
      containerWidth: _constant2.DEFAULT_CONFIG.LOGINMENU.WIDTH,
      bigmemberId: userInfo.bigmemberId,
      bigPoints: bigPoints,
      loyaltyTier: userInfo.loyaltyTier,
      isClosed: MenuClose,
      doLogout: logout,
      accessible: accessible,
      showBigLoyaltyPoints: showBigLoyaltyPoints,
      creditBalance: creditBalance,
      showCreditBalance: showCreditBalance
    })), tooltipdata && showTooltip && !isMobile && /*#__PURE__*/_react.default.createElement(LoginMenuWrapper, {
      MenuOnLeft: MenuOnLeft
    }, /*#__PURE__*/_react.default.createElement(_LoginTooltip.default, {
      accessible: accessible,
      align: MenuOnLeft ? _constant2.DEFAULT_CONFIG.TOOLTIP.LEFT : _constant2.DEFAULT_CONFIG.TOOLTIP.RIGHT,
      data: tooltipInfo,
      position: _constant2.DEFAULT_CONFIG.TOOLTIP.POSITION,
      show: true,
      viewport: _constant2.DEFAULT_CONFIG.TOOLTIP.VIEWPORT
    }))), /*#__PURE__*/_react.default.createElement(_index.default, {
      isMobile: isMobile,
      handleClick: handleClick,
      setLoginInfo: setLoginInfo,
      deviceType: deviceType,
      loginclicked: loginclicked,
      environment: environment,
      doPolling: doPolling,
      setDuplicateCookieAATokens: setDuplicateCookieAATokens,
      reloadOnLogin: reloadOnLogin,
      shouldSetCookie: shouldSetCookie,
      loginStatus: loginStatus,
      loginLabel: loginLabel,
      setBigPoints: setBigPoints,
      enableFavoriteMembers: enableFavoriteMembers,
      enableBigPoints: enableBigPoints,
      setLoginStatusCallback: setLoginStatusCallback,
      setUserInfoCallback: setUserInfoCallback,
      locale: locale,
      currency: currency,
      showBigLoyaltyPoints: handleBigLoyaltyPointsDisplay,
      getBaseDomain: getBaseDomain,
      setCreditBalance: setCreditBalance,
      enableCreditBalance: enableCreditBalance,
      showCreditBalance: handleCreditBalanceDisplay
    }));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Login.propTypes = _login.default.PropTypes;
Login.defaultProps = _login.default.DefaultProps;
var _default = Login;
exports.default = _default;